export default __webpack_public_path__ + "static/media/rinky.f7eb8fe0.jpg";